(() => {
  function getModalByKey(key) {
    if (!key) return null;

    const modals = document.querySelectorAll('[data-pdp-clinician-modal]');

    for (const modal of modals) {
      if (modal.getAttribute('data-pdp-clinician-modal') === key) {
        return modal;
      }
    }

    return null;
  }

  function openClinicianModal(key) {
    const modal = getModalByKey(key);

    if (!modal) {
      console.warn('Clinician popup not found for key:', key);
      return;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pdp-clinician-modal-open');
    document.body.classList.add('pdp-clinician-modal-open');
  }

  function closeClinicianModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pdp-clinician-modal-open');
    document.body.classList.remove('pdp-clinician-modal-open');
  }

  document.addEventListener('click', function(event) {
    const openButton = event.target.closest('[data-pdp-clinician-open]');

    if (openButton) {
      event.preventDefault();
      event.stopPropagation();

      const popupKey = openButton.getAttribute('data-pdp-clinician-open');
      openClinicianModal(popupKey);
      return;
    }

    const badgeClose = event.target.closest('[data-pdp-clinician-badge-close]');

    if (badgeClose) {
      event.preventDefault();
      event.stopPropagation();

      const badge = badgeClose.closest('[data-pdp-clinician-badge]');
      if (badge) {
        badge.classList.add('is-dismissed');
      }
      return;
    }

    const modalClose = event.target.closest('[data-pdp-clinician-close]');

    if (modalClose) {
      event.preventDefault();

      const modal = modalClose.closest('[data-pdp-clinician-modal]');
      closeClinicianModal(modal);
      return;
    }

    const overlay = event.target.closest('[data-pdp-clinician-overlay]');

    if (overlay) {
      const modal = overlay.closest('[data-pdp-clinician-modal]');
      closeClinicianModal(modal);
    }
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const openModal = document.querySelector('[data-pdp-clinician-modal].is-open');
      closeClinicianModal(openModal);
    }
  });

  /* Subtle desktop-only above-the-fold parallax */
  function initClinicianParallax() {
    const parallaxSections = document.querySelectorAll(
      '.product-section[data-clinician-parallax="true"]'
    );

    if (!parallaxSections.length) return;

    let ticking = false;

    function updateParallax() {
      if (window.innerWidth < 768) {
        parallaxSections.forEach((section) => {
          section.style.setProperty('--pdp-clinician-parallax-y', '0px');
        });
        ticking = false;
        return;
      }

      parallaxSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        const viewport = window.innerHeight || 900;

        if (rect.bottom <= 0 || rect.top >= viewport) {
          section.style.setProperty('--pdp-clinician-parallax-y', '0px');
          return;
        }

        const progress = (viewport * 0.38 - rect.top) / viewport;
        const translate = Math.max(-18, Math.min(18, progress * 18));

        section.style.setProperty(
          '--pdp-clinician-parallax-y',
          `${translate.toFixed(2)}px`
        );
      });

      ticking = false;
    }

    function requestUpdate() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    updateParallax();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  initClinicianParallax();
})();